import type { ViewModelEntity } from '@view-model/domain/view-model';
import type { Workspace } from '@workspace/domain/workspace';
import { ViewModelItemTitle } from '../../items';

type Props = {
  viewModel: ViewModelEntity;
  workspace: Workspace;
  searchKeyword: string;
};

export const KataSearchViewModelItem: React.FC<Props> = ({ viewModel, workspace, searchKeyword }: Props) => {
  return (
    <div className="hover:bg-gray-300 focus:outline-none">
      <ViewModelItemTitle viewModel={viewModel} workspace={workspace} searchKeyword={searchKeyword} isExternal />
    </div>
  );
};
